const certificate = [

];

export default certificate;